export default "__VITE_ASSET__2454b711__"